import react, { forwardRef, useContext, useState } from 'react';
import Swal from 'sweetalert2';

import AuthContext from '../../context/authentication/authContex';

import './Dictionary.css';

const Dictionary = forwardRef(({updated, setUpdated, handleChange, handleSave}, ref) => {

    return <div className='dictionaryView' ref={ref}>
        {/* <div className='dictionaryFixedDiv'>
        </div> */}
        <div className='tableDiv'>
            <h3>Ubicaciones</h3>
            <div className='tableHeader'>
                <div className='rowDictionary'>
                    <h5>Nombre Original</h5>
                    <h5>Nombre Personalizado</h5>
                    <h5></h5>
                </div>
            </div>
            <div className='tableBody'>
                {updated?.dictionary?.ubicaciones?.map(kv => <div className='rowDictionary'>
                    <input disabled value={kv.original}/>
                    <input onChange={(e) => handleChange(e, 'ubicaciones')} name={kv.original} value={kv.actual}/>
                    <span>Ej: Área, Planta, Proceso, Sector</span>
                </div>)} 
            </div>
        </div>
        <div className='tableDiv'>
            <h3>Origen</h3>
            <div className='tableHeader'>
                <div className='rowDictionary'>
                    <h5>Nombre Original</h5>
                    <h5>Nombre Personalizado</h5>
                    <h5></h5>
                </div>
            </div>
            <div className='tableBody'>
                {updated?.dictionary?.origen?.map(kv => <div className='rowDictionary'>
                    <input disabled value={kv.original}/>
                    <input onChange={(e) => handleChange(e, 'origen')} name={kv.original} value={kv.actual}/>
                    <span>{kv.original == 'Proc. Calculados' ? 'Ej: Mant. Preventivos, Mant. Rutinarios' : kv.original == 'Proc. desde Checklist' ? 'Ej: Proc. por Controles Fallidos, Mant. Predictivo' : 'Ej: Mant. Correctivos, Mant. por Roturas o Mejoras'}</span>
                </div>)} 
            </div>
        </div>
        {/* <button onClick={handleSave} className='saveDictionaryBtn'>guardar</button> */}
    </div>

})

export default Dictionary;